<woa-icon class="toggle-indicator" name="angle-down" [ngClass]="{'active': active()}"></woa-icon>
